import { AnyStateConfig, setup } from 'xstate';

import { FlowEntity, InitMachineParams } from '../../types';
import { resolveRegionalizedUrl } from '../rendezvous/resolveRegionalizedUrl';
import type { RendezvousFlowContext } from '../rendezvous/types';

type TvSelectBlueprintInput = { url: string; includeRegionInUrl?: boolean };
type TvSelectInputActorInput = { defaultRegionCode: string };
type TvSelectInput = TvSelectBlueprintInput & TvSelectInputActorInput;

export const tvSelectFlow: FlowEntity = {
    initActor: (rawParams) => {
        const { config, actors, router, region } = rawParams as InitMachineParams;
        return setup({
            types: {
                input: {} as TvSelectInput,
            },
            guards: {},
            actions: {
                goToTvSelectRoute: ({ context }) => {
                    router.push(context.url);
                },
            },
            actors,
        }).createMachine({
            ...(config as AnyStateConfig),
            context: ({ input }) => {
                return {
                    ...input,
                    url: resolveRegionalizedUrl(region, input),
                };
            },
        });
    },
    inputActor: ({ context }: { context: RendezvousFlowContext }): TvSelectInputActorInput => {
        return {
            defaultRegionCode: context.defaultRegionCode,
        };
    },
};
